<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2022-05-17 14:15:42
 * @LastEditors: wangwang 2723008256@qq.com
 * @LastEditTime: 2022-05-17 17:34:16
 * @FilePath: \jzjypc4.0\src\views\PersonalCenter\MyData\AllData\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="container">
    <div class="top">
      <div class="dayTime box">
        <h3>入驻天数</h3>
        <span>{{ 365 }}</span>
        天
      </div>
      <div class="userNum box">
        <h3>本校已注册人数</h3>
        <span>{{ 124 }}</span>
        人
      </div>
      <div class="updateNum box">
        <h3>资源下载数</h3>
        <span>{{ 1365 }}</span>
        份
      </div>
      <div class="lineTime box">
        <h3>在线时长</h3>
        <span>{{ 1 }}</span
        >h <span>{{ 34 }}</span
        >min
      </div>
      <div class="seeyouNum box">
        <h3>访问次数</h3>
        <span>{{ 24 }}</span>
        次
      </div>
      <div class="activeNum box">
        <h3>参与活动次数</h3>
        <span>{{ 134 }}</span>
        次
      </div>
    </div>
    <div class="content">
      <div class="activeData">
        <div class="toper">
          <h3>活动数据</h3>
          <h4>
            您共参加过
            <span>{{ 1 }}</span>
            次在线教研活动
          </h4>
        </div>
        <div class="box">
          <img src="" alt="" />
          <div class="msg">
            <div class="title">
              高一语文《红楼梦》与《乡土中国》在线协 同教研
            </div>
            <div class="update">活动心得已更新38份</div>
            <p>2022-05-05 （星期六） 12:00</p>
          </div>
        </div>
        <div class="details">
          <div class="liveTime">
            <img src="" alt="" />
            <div class="num">
              <p>直播时长</p>
              <span><a>1</a>h<a>24</a>min</span>
            </div>
          </div>
          <div class="perNum">
            <img src="" alt="" />
            <div class="num">
              <p>学校参与人数</p>
              <span><a>124</a>人</span>
            </div>
          </div>
          <div class="seeTime">
            <img src="" alt="" />
            <div class="num">
              <p>观看时长</p>
              <span><a>46</a>min</span>
            </div>
          </div>
        </div>
        <div class="teacherForm">
          <p>参与活动老师列表：</p>

          <el-table
            :data="tableData"
            style="width: 100%"
            stripe
            :default-sort="{ prop: 'date', order: 'descending' }"
          >
            <el-table-column prop="name" label="姓名" width="110">
            </el-table-column>
            <el-table-column
              prop="time"
              label="观看时长(分钟)"
              sortable
              width="132"
            >
            </el-table-column>
            <el-table-column
              prop="speakNum"
              label="发言次数"
              sortable
              width="122"
            >
            </el-table-column>
            <el-table-column
              prop="gift"
              label="送礼物次数"
              sortable
              width="124"
            >
            </el-table-column>
            <el-table-column prop="good" label="点赞次数" sortable width="122">
            </el-table-column>
          </el-table>
          <p class="seeMore">展开查看全部</p>
        </div>
      </div>
      <div class="resourceData">
        <h3>资源数据</h3>
        <div class="leiji">
          <div class="check">
            <img src="" alt="" />
            <div class="num">
              <p>累计查看</p>
              <span><a>200</a>份</span>
            </div>
          </div>
          <div class="share">
            <img src="" alt="" />
            <div class="num">
              <p>累计分享</p>
              <span><a>200</a>份</span>
            </div>
          </div>
          <div class="update">
            <img src="" alt="" />
            <div class="num">
              <p>累计分享</p>
              <span><a>200</a>份</span>
            </div>
          </div>
        </div>
        <div class="tcherStudyNum">
          <p>在校老师学习排行榜：</p>

          <el-table
            :data="tableData"
            style="width: 100%"
            stripe
            :default-sort="{ prop: 'date', order: 'descending' }"
          >
            <el-table-column prop="name" label="姓名" width="110">
            </el-table-column>
            <el-table-column
              prop="time"
              label="观看时长(分钟)"
              sortable
              width="132"
            >
            </el-table-column>
            <el-table-column
              prop="speakNum"
              label="发言次数"
              sortable
              width="122"
            >
            </el-table-column>
            <el-table-column
              prop="gift"
              label="送礼物次数"
              sortable
              width="124"
            >
            </el-table-column>
            <el-table-column prop="good" label="点赞次数" sortable width="122">
            </el-table-column>
          </el-table>
          <p class="seeMore">展开查看全部</p>
        </div>
      </div>
      <div class="productData">
        <h3>产品数据</h3>
        <span>老师们正在看的书</span>
        <div class="proBox">
          <div class="box" v-for="item in 2" :key="item">
            <img src="" alt="" />
            <div class="msg">
              <p>高中语文阅读新思路·建构与提升 第一册 精读</p>
              <span
                >浏览过<a>{{ 20 }}</a
                >次，本校超过<a>{{ 20 }}%</a>的老师在看</span
              >
            </div>
          </div>
        </div>
        <p class="seeMore">展开查看更多</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          name: "王小虎",
          time: 5,
          speakNum: 6,
          gift: 43,
          good: 783,
        },
        {
          name: "王小虎",
          time: 4,
          speakNum: 9,
          gift: 0,
          good: 20,
        },
        {
          name: "王小虎",
          time: 23,
          speakNum: 1,
          gift: 2,
          good: 89,
        },
        {
          name: "王小虎",
          time: 67,
          speakNum: 8,
          gift: 0,
          good: 23,
        },
        {
          name: "王小虎",
          time: 32,
          speakNum: 6,
          gift: 40,
          good: 23,
        },
        {
          name: "王小虎",
          time: 90,
          speakNum: 6,
          gift: 2,
          good: 23,
        },
        {
          name: "王小虎",
          time: 67,
          speakNum: 78,
          gift: 10,
          good: 33,
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
#container {
  padding-left: 20px;
  width: 700px;
  border-left: 1px solid #dee0e3;
  .top {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 30px;
    width: 670px;
    .box {
      margin-bottom: 10px;
      width: 210px;
      height: 80px;
      color: #fff;
      font-size: 12px;
      h3 {
        margin: 15px;
        margin-bottom: 8px;
      }
      span {
        margin-left: 15px;
        font-size: 28px;
      }
    }
    .dayTime {
      background-color: #8eaafa;
    }
    .userNum {
      background-color: #ff40dcc0;
    }
    .updateNum {
      background-color: #6ad791;
    }
    .lineTime {
      background-color: #7dbbfa;
    }
    .seeyouNum {
      background-color: #fc9697;
    }
    .activeNum {
      background-color: #fab87d;
    }
  }
  .content {
    /deep/.cell {
      text-align: center;
    }
    /deep/.el-table th.el-table__cell {
      background-color: #aec0f6;
    }
    /deep/.el-table thead {
      color: #fff;
    }
    /deep/.el-table .sort-caret.descending {
      border-top-color: #e4e4e4;
    }
    /deep/.el-table .sort-caret.ascending {
      border-bottom-color: #e4e4e4;
    }
    /deep/.el-table .ascending .sort-caret.ascending {
      border-bottom-color: #fff;
    }
    /deep/.el-table .descending .sort-caret.descending {
      border-top-color: #fff;
    }
    /deep/ td.el-table__cell {
      background-color: #eaf3ff;
    }
    /deep/.el-table--striped
      .el-table__body
      tr.el-table__row--striped
      td.el-table__cell {
      background-color: #dbe4fd;
    }
    .activeData {
      margin-bottom: 30px;
      width: 670px;
      color: #646566;
      font-size: 14px;
      background: linear-gradient(30deg, #e6effa, #dcecfc, #dce5fb, #e8f7ff);
      overflow: hidden;
      span {
        font-size: 36px;
        font-family: DIN;
        font-weight: bold;
        color: #7393f0;
      }
      h3 {
        margin: 30px 0 10px 30px;
        color: #333333;
        font-size: 16px;
      }
      h4 {
        margin-left: 30px;
        margin-bottom: 10px;
      }
      .box {
        display: flex;
        margin: 0 auto;
        width: 610px;
        height: 160px;
        background-color: #eaf3fe;
        img {
          margin: 20px;
          width: 233px;
          height: 120px;
          background: #e4e4e4;
        }
        .msg {
          margin: 20px 32px 20px 0;
          .title {
            margin-bottom: 12px;
            font-size: 16px;
            color: #333333;
            font-weight: 600;
          }
          .update {
            width: 128px;
            height: 24px;
            background: #fdeff0;
            border-radius: 4px;
            color: #f63842;
            line-height: 42px;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
            margin-bottom: 25px;
          }
        }
      }
      .details {
        display: flex;
        margin-bottom: 20px;
        margin-top: 30px;
        div {
          display: flex;
          margin-left: 30px;
          img {
            margin-right: 10px;
            width: 48px;
            height: 48px;
            background: #aec0f6;
            border-radius: 50%;
          }
          .num {
            display: flex;
            flex-direction: column;
            margin: 0;
            p {
              font-size: 12px;
              color: #969799;
            }
            span {
              font-size: 12px;
              color: #969799;
              a {
                font-size: 24px;
                font-weight: bold;
                color: #646566;
              }
            }
          }
        }
      }
      .teacherForm {
        p {
          margin-bottom: 20px;
          margin-left: 30px;
        }
        /deep/.el-table {
          margin: 0 auto;
          width: 610px !important;
        }
        .seeMore {
          margin-top: 20px;
          text-align: center;
          font-size: 12px;
          color: #969799;
        }
      }
    }
    .resourceData {
      margin-bottom: 30px;
      width: 670px;
      background: linear-gradient(-30deg, #fadfd2, #fae9df, #f9dbc8, #fef6f3);
      overflow: hidden;
      h3 {
        margin: 30px;
        color: #333333;
        font-size: 16px;
      }
      .leiji {
        display: flex;
        margin-bottom: 20px;
        div {
          display: flex;
          margin-left: 30px;
          img {
            margin-right: 10px;
            width: 48px;
            height: 48px;
            background: #f9cdb7;
            border-radius: 50%;
          }
          .num {
            display: flex;
            flex-direction: column;
            margin: 0;
            p {
              font-size: 12px;
              color: #969799;
            }
            span {
              font-size: 12px;
              color: #969799;
              a {
                font-size: 24px;
                font-weight: bold;
                color: #646566;
              }
            }
          }
        }
      }
      .tcherStudyNum {
        p {
          margin: 30px 0 20px 30px;
          font-size: 14px;
          color: #646566;
        }
        /deep/.el-table th.el-table__cell {
          background-color: #f9cdb7;
        }
        /deep/ td.el-table__cell {
          background-color: #fdf2ed;
        }
        /deep/.el-table--striped
          .el-table__body
          tr.el-table__row--striped
          td.el-table__cell {
          background-color: #fbe5db;
        }
        /deep/.el-table {
          margin: 0 auto;
          width: 610px !important;
        }
        .seeMore {
          margin-top: 20px;
          text-align: center;
          font-size: 12px;
          color: #969799;
        }
      }
    }
    .productData {
      margin-bottom: 60px;
      width: 670px;
      background: linear-gradient(120deg, #e6faf8, #dcfcfc, #dbfbf6, #e8fff8);
      overflow: hidden;
      h3 {
        margin: 30px;
        color: #333333;
        font-size: 16px;
      }
      span {
        margin-left: 30px;
        font-size: 14px;
        color: #646566;
      }
      .proBox {
        margin: 0 auto;
        width: 610px;
        height: 310px;
        background-color: #e8fffc;
        .box {
          display: flex;
          margin: 20px 0 30px 20px;
          img {
            width: 90px;
            height: 120px;
            border: 1px solid #dddedb;
          }
          .msg {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            margin-left: 20px;
            p {
              font-size: 14px;
              color: #333333;
            }
            span {
              margin: 0;
              color: #939599;
              line-height: 34px;
              a {
                font-size: 36px;
                font-family: DIN;
                font-weight: bold;
                color: #24ba90;
              }
            }
          }
        }
      }
      .seeMore {
        padding: 20px 0 50px 0;
        text-align: center;
        color: #969799;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}
</style>
